import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { cn } from "../../../utils";
export function AiThinkingIndicator({ phases, intervalMs = 1800, variant = "checklist", cycle = variant === "inline", onCycle, className }) {
    const [active, setActive] = useState(0);
    const onCycleRef = useRef(onCycle);
    onCycleRef.current = onCycle;
    useEffect(function cycleThinkingPhases() {
        if (phases.length <= 1) return;
        if (!cycle && active >= phases.length - 1) return;
        const id = setInterval(()=>{
            const next = active + 1;
            if (next >= phases.length) {
                if (cycle) {
                    // Fire from the timer callback, not a state updater — invoking the
                    // parent's onCycle (a setState) during render phase trips React's
                    // "cannot update a component while rendering a different one" warning.
                    onCycleRef.current?.();
                    setActive(0);
                } else {
                    setActive(phases.length - 1);
                }
            } else {
                setActive(next);
            }
        }, intervalMs);
        return ()=>clearInterval(id);
    }, [
        phases.length,
        intervalMs,
        cycle,
        active
    ]);
    if (variant === "inline") {
        return /*#__PURE__*/ _jsx("span", {
            className: cn("shimmer block text-sm", className),
            "aria-live": "polite",
            children: phases[active]
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        className: cn("space-y-1.5", className),
        "aria-live": "polite",
        children: phases.map((label, i)=>{
            const done = i < active;
            const current = i === active;
            return /*#__PURE__*/ _jsxs("li", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: cn("inline-flex h-4 w-4 items-center justify-center rounded-full shrink-0", done && "bg-bliks-green-500 text-white", current && "border border-bliks-green-500 text-bliks-green-600", !done && !current && "border border-line text-fg-disabled"),
                        children: [
                            done && /*#__PURE__*/ _jsx(Check, {
                                className: "h-2.5 w-2.5",
                                strokeWidth: 3
                            }),
                            current && /*#__PURE__*/ _jsx(Loader2, {
                                className: "h-2.5 w-2.5 animate-spin"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: cn(done && "text-muted-foreground", current && "font-medium text-foreground", !done && !current && "text-muted-foreground/60"),
                        children: label
                    })
                ]
            }, i);
        })
    });
}

//# sourceMappingURL=AiThinkingIndicator.js.map